/**
 * Created by guga on 8/19/2016.
 */

import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

import { AuthXhrSas }                         from './auth-xhr.sas';
import { ErrorHandlerBuilderSas }             from './error-handler-builder.sas';

import { IXhrHeaders, IXhrResponse, IXhrOptions, IXhrRequestPayload } from '../sas-models/xhr-types';
import { IXhrErrorHandler }                                           from "../sas-models/error-handler";

/***********************************************
 * Author : Gustavo(gmm)
 * Date   : 19/08/2016
 *
 * This service is a wrapper for AuthXhrSas. It hides common code like map and catch from observables. It also provide an IXhrRequestPayload for errorHandlers.
 *
 * All request methods(get, post, postJson) use ErrorHandlerService as error handler. If you want to use error handlers separate from ErrorHandlerService
 * see request method.
 *
 * This is the preferred service to do authenticated requests(using tokens). If you want to use pure authenticated requests without IXhrRequestPayload or without common observables operators
 * then use AuthXhrSas directly instead. Low level use XhrSas(without token).
 *
 * This service also provides a request methods. Use this method if you want to write custom error handlers / custom services that implement custom different
 * error handler for each request.
 *
 * This service fulfill IXhrRequestPayload as follows :
 *   path     : original url (string)
 *   headers  : original headers
 *   options  : original options (RequestOptions)
 *   method   : method used (get, post)
 *   data     : original data
 *   isJson   : indicate is the method is using data string as json
 *
 * If you use ErrorHandlerService to implement a custom error handler, you will want to take advantages of IXhrRequestPayload to gather information about the request
 *
 ***********************************************/

@Injectable()
export class AuthXhrWrapperSas {

    public constructor(private _authXhr : AuthXhrSas, private _ehb : ErrorHandlerBuilderSas) {}

    public get(path : string, headers ?: IXhrHeaders, options ?: IXhrOptions, xhrErrorHandler ?: IXhrErrorHandler) : Observable<IXhrResponse> {
        let xhrRequestPayload : IXhrRequestPayload = {
            path    : path,
            headers : headers,
            options : options,
            method  : "GET",
            isJson  : false
        };

        return this._authXhr.get(path, headers, options)
            .catch( this._ehb.buildXhrErrorHandler(xhrErrorHandler, xhrRequestPayload) );
    }

    public post(path : string, data ?: any, headers ?: IXhrHeaders, options ?: IXhrOptions, xhrErrorHandler ?: IXhrErrorHandler) : Observable<IXhrResponse> {
        let xhrRequestPayload : IXhrRequestPayload = {
            path    : path,
            headers : headers,
            options : options,
            method  : "POST",
            data    : data,
            isJson  : false
        };

        return this._authXhr.post(path, data, headers, options)
            .catch( this._ehb.buildXhrErrorHandler(xhrErrorHandler, xhrRequestPayload) );
    }

    public postJson(path : string, data ?: string, headers ?: IXhrHeaders, options ?: IXhrOptions, xhrErrorHandler ?: IXhrErrorHandler) : Observable<IXhrResponse> {
        let xhrRequestPayload : IXhrRequestPayload = {
            path    : path,
            headers : headers,
            options : options,
            method  : "POST",
            data    : data,
            isJson  : true
        };

        return this._authXhr.postJson(path, data, headers, options)
            .catch( this._ehb.buildXhrErrorHandler(xhrErrorHandler, xhrRequestPayload) );
    }

    public request(xhrPayload : IXhrRequestPayload, xhrErrorHandler ?: IXhrErrorHandler) : Observable<IXhrResponse> {
        if (!xhrPayload.isJson)
            return this._authXhr.request(xhrPayload.method, xhrPayload.path, xhrPayload.data, xhrPayload.headers, xhrPayload.options).
                catch( this._ehb.buildXhrErrorHandler(xhrErrorHandler,xhrPayload) );

        switch (xhrPayload.method.toUpperCase()) {
            case "POST" :
                return this._authXhr.postJson(xhrPayload.path, xhrPayload.data, xhrPayload.headers, xhrPayload.options).
                    catch( this._ehb.buildXhrErrorHandler(xhrErrorHandler, xhrPayload) );
            default :
                return Observable.throw('Undefined method');
        }
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/auth-xhr-wrapper.sas.ts